import { loadAllFilmAvailabilities } from './load-all-film-availabilities';
import { loadFilmAvailabilitiesForSite } from './load-film-availabilities-for-site';
export const loadFilmAvailabilities = async (siteId) => {
    if (siteId)
        return loadFilmAvailabilitiesForSite(siteId);
    else
        return loadAllFilmAvailabilities();
};
